<template>
  <div>
    <div class="input-search">
      Tìm kiếm
      <label>
        <gmap-autocomplete @place_changed="setPlace"> </gmap-autocomplete>
        <!-- <button @click="addMarker">Add</button> -->
      </label>
    </div>
    <gmap-map
      :center="center"
      :zoom="17"
      :style="`width: 100%; min-height: ${heightEditor}`"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    positionVulue: Array,
    height: String,
  },
  data() {
    return {
      heightEditor: this.height ? this.height : "450px",
      center: { lat: 21, lng: 105.75 },
      markers: [],
      places: [],
      currentPlace: null,
    };
  },

  mounted() {
    this.geolocate();
  },
  watch: {
    positionVulue(oldValue, newValue) {
      this.geolocate();
    },
    height: function () {
      this.heightEditor = this.height;
    },
  },

  methods: {
    // nhận địa điểm thông qua autocomplete component
    setPlace(place) {
      this.currentPlace = place;
      console.log("this.currentPlace", this.currentPlace);
    },

    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: this.positionVulue[1],
          lng: this.positionVulue[0],
        };
      });
      this.center = {
        lat: this.positionVulue[1],
        lng: this.positionVulue[0],
      };
      this.markers.push({ position: this.center }); // hiển thị vị trí
    },
  },
};
</script>
<style scoped lang="scss">
.input-search {
  text-align: end;
  margin-bottom: 5px;
  .pac-target-input {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    padding-left: 10px;
    &:focus {
      outline: none;
    }
  }
}
</style>
